import { HubConnectionBuilder, HubConnectionState, LogLevel } from '@microsoft/signalr';

import _ from "lodash";
import { eventLogActions } from '../slices/eventLogSlice';
import { heartbeatActions } from '../slices/heartbeatSlice';
import log from 'loglevel';
import { messagingChannelActions } from '../slices/messagingChannelSlice';
import { pageNotiActions } from '../../src/slices/pageNotificationSlice';
import { recordingFilesActions } from '../slices/recordingFileSlice';
import { userSessionActions } from '../slices/userSessionSlice';

const signalRManager = {
    init: (dispatcher, getState, initPayload) => {
        log.info("initialized signalr ..... ");
        log.info(initPayload)
        const url = initPayload.url;
        const token = initPayload.token;
        log.info("Starting hubConnection with url ... " + initPayload.url);
        const hubConnection = new HubConnectionBuilder()
            .withUrl(`${url}`
                , {
                    accessTokenFactory: () =>
                        token,
                    transport: 4
                }
            )
            .configureLogging(LogLevel.Critical)
            .withAutomaticReconnect()
            .build();
        //revalidate subscription after connection connected.
        const revalidateSubscriptions = () => {
            log.info("Revalidate subscriptions...");
            const messagingChannel = getState().messagingChannel;
            if (messagingChannel.subRecordingStatusPayload) {
                unsubscribeRecordingStatus(messagingChannel.subRecordingStatusPayload);
                subscribeRecordingStatus(messagingChannel.subRecordingStatusPayload);
            }
            if (messagingChannel.subSessionStatusPayload) {
                unsubscribeSessionStatus(messagingChannel.subSessionStatusPayload);
                subscribeSessionStatus(messagingChannel.subSessionStatusPayload);
            }
            if (messagingChannel.subArchiveStatusPayload) {
                unsubscribeArchiveStatus(messagingChannel.subArchiveStatusPayload);
                subscribeArchiveStatus(messagingChannel.subArchiveStatusPayload);
            }
            if (messagingChannel.subDownloadTrimPayload) {
                unsubscribeDownloadTrimStatus(messagingChannel.subDownloadTrimPayload);
                subscribeDownloadTrimStatus(messagingChannel.subDownloadTrimPayload);
            }
            if (messagingChannel.subExportCSVPayload) {
                unsubscribeExportCSVStatus(messagingChannel.subExportCSVPayload);
                subscribeExportCSVStatus(messagingChannel.subExportCSVPayload);
            }
            log.info("Revalidate subscriptions done.");
        }

        const dumpConnectionLog = () => log.info("hubConnection state changed %o", hubConnection.state);
        hubConnection != null && hubConnection.onreconnecting(dumpConnectionLog);
        hubConnection != null && hubConnection.onreconnected(() => {
            log.info("hubConnection state changed %o", "Reconnected");
            revalidateSubscriptions();
        });
        hubConnection != null && hubConnection.onclose(() => {
            dumpConnectionLog();
            log.info("Will retry connection in next (5) seconds.\t%o", JSON.stringify(new Date()));
            setTimeout(startConnection, 5000);
        });

        const isConnected = () => hubConnection != null ? hubConnection.state === HubConnectionState.Connected : false;

        const startConnection = () => {
            if (hubConnection == null || hubConnection.state === HubConnectionState.Disconnected) {

                hubConnection != null && hubConnection.start().then(() => {
                    dumpConnectionLog();
                    revalidateSubscriptions();
                }).catch(ex => {
                    console.warn("start connection error");
                    dispatcher(messagingChannelActions.connectionError(ex.message));
                    log.info("Will retry connection in next (5) seconds. \t%o", JSON.stringify(new Date()));
                    setTimeout(startConnection, 5000);
                });
            }
        }

        const subscribeRecordingStatus = (payload) => {
            log.info("subscribeRecordingStatus payload %o", payload);
            hubConnection != null && hubConnection.invoke("subscribeRecordingStatus", payload.userId)
                .then((channelId) => {
                    log.info("recording status channelId", channelId);
                    hubConnection != null && hubConnection.on(channelId, message => {
                        log.info("message response from signalR channel => ", message);
                        dispatcher(pageNotiActions.setRecordingProgressNotification(message));
                    });
                }).catch(() => {
                    log.error("subscribeRecordingStatus error");
                });
        }
        const unsubscribeRecordingStatus = (payload) => {
            log.info("unsubscribeRecordingStatus payload %o", payload);
            hubConnection != null && hubConnection.invoke("unsubscribeRecordingStatus", payload.userId)
                .then((channelId) => {
                    hubConnection != null && hubConnection.off(channelId);
                }).catch(() => {
                    log.error("unsubscribeRecordingStatus error");
                });
        }

        const subscribeArchiveStatus = (payload) => {
            log.info("subscribeArchiveStatus payload %o", payload);
            hubConnection != null && hubConnection.invoke("subscribeArchiveStatus", payload.userId)
                .then((channelId) => {
                    log.info("archived channelId", channelId);
                    hubConnection != null && hubConnection.on(channelId, message => {
                        let recordingWithStatuses = message.recordingWithStatuses;
                        _.map(recordingWithStatuses, x => dispatcher(pageNotiActions.setRecordingAndArchivedNotifications(x)))
                        log.info("message response from signalR channel subscribeArchiveStatus => ", message);

                    });
                }).catch(() => {
                    log.error("subscribeArchiveStatus error",);
                });
        }
        const unsubscribeArchiveStatus = (payload) => {
            log.info("unsubscribeArchiveStatus payload %o", payload);
            hubConnection != null && hubConnection.invoke("unsubscribeArchiveStatus", payload.userId)
                .then((channelId) => {
                    hubConnection != null && hubConnection.off(channelId);
                }).catch(() => {
                    log.error("unsubscribeArchiveStatuss error ");
                });
        }

        const subscribeSessionStatus = (payload) => {
            log.info("subscribeSessionStatus payload %o", payload);
            hubConnection != null && hubConnection.invoke("subscribeSessionStatus", payload.userId)
                .then((channelId) => {
                    log.info("session channelId ", channelId);
                    hubConnection != null && hubConnection.on(channelId, message => {
                        log.info("Received session status changed =>", message);
                        message == 'InActivity' ?
                            dispatcher(heartbeatActions.openDialog(true)) :
                            dispatcher(userSessionActions.openDialog({
                                open: true,
                                msgType: message
                            }));
                    });
                }).catch(() => {
                    log.error("subscribeSessionStatus error %o");
                });
        }
        const unsubscribeSessionStatus = (payload) => {
            log.info("unsubscribeSessionStatus payload %o", payload);
            hubConnection != null && hubConnection.invoke("unsubscribeSessionStatus", payload.userId)
                .then((channelId) => {
                    hubConnection != null && hubConnection.off(channelId);
                }).catch(() => {
                    log.error("unsubscribeSessionStatus error");
                });
        }

        const subscribeDownloadTrimStatus = (payload) => {
            log.info("subscribeDownloadTrimStatus payload %o", payload);
            hubConnection != null && hubConnection.invoke("subscribeDownloadTrimStatus", payload.userId)
                .then((channelId) => {
                    log.info("Download Trim status channelId", channelId);
                    hubConnection != null && hubConnection.on(channelId, message => {
                        log.info("message response from signalR channel => ", message);
                        dispatcher(recordingFilesActions.updateTrimDownloadUrl(message));
                    });
                }).catch(() => {
                    log.error("subscribeDownloadTrimStatus error");
                });
        }
        const unsubscribeDownloadTrimStatus = (payload) => {
            log.info("unsubscribeDownloadTrimStatus payload %o", payload);
            hubConnection != null && hubConnection.invoke("unsubscribeDownloadTrimStatus", payload.userId)
                .then((channelId) => {
                    hubConnection != null && hubConnection.off(channelId);
                }).catch(() => {
                    log.error("unsubscribeDownloadTrimStatus error");
                });
        }
        const subscribeExportCSVStatus = (payload) => {
            log.info("subscribeExportCSVStatus payload %o", payload);
            hubConnection != null && hubConnection.invoke("subscribeExportCSVStatus", payload.userId)
                .then((channelId) => {
                    log.info("Export CSV status channelId", channelId);
                    hubConnection != null && hubConnection.on(channelId, message => {
                        log.info("message response from signalR channel => ", message);
                        dispatcher(eventLogActions.updateDownloadUrl(message));
                    });
                }).catch(() => {
                    log.error("subscribeExportCSVStatus error");
                });
        }
        const unsubscribeExportCSVStatus = (payload) => {
            log.info("unsubscribeExportCSVStatus payload %o", payload);
            hubConnection != null && hubConnection.invoke("unsubscribeExportCSVStatus", payload.userId)
                .then((channelId) => {
                    hubConnection != null && hubConnection.off(channelId);
                }).catch(() => {
                    log.error("unsubscribeExportCSVStatus error");
                });
        }
        return {
            isConnected,
            startConnection,

            subscribeRecordingStatus,
            unsubscribeRecordingStatus,
            subscribeArchiveStatus,
            unsubscribeArchiveStatus,

            subscribeSessionStatus,
            unsubscribeSessionStatus,

            subscribeDownloadTrimStatus,
            unsubscribeDownloadTrimStatus,

            subscribeExportCSVStatus,
            unsubscribeExportCSVStatus
        };
    }
}

let managerInstance = null;
const signalRMiddleware = ({ dispatch, getState }) => (next) => (action) => {
    try {
        if (messagingChannelActions.startConnecting.match(action)) {
            if (!managerInstance) managerInstance = signalRManager.init(dispatch, getState, action.payload);
            managerInstance.startConnection();
        }
        if (managerInstance?.isConnected()) {
            handleActionType(action);
        }
    } catch (ex) {
        log.error("Exception at signalRMiddleware %o", ex);
    }

    next(action);
}

export default signalRMiddleware;

const handleActionType = (action) => {
    switch (action) {
        case messagingChannelActions.subscribeRecordingStatus.match:
            managerInstance.subscribeRecordingStatus(action.payload);
            break;
        case messagingChannelActions.unsubscribeRecordingStatus.match:
            managerInstance.unsubscribeRecordingStatus(action.payload);
            break;
        case messagingChannelActions.subscribeArchiveStatus.match:
            managerInstance.subscribeArchiveStatus(action.payload);
            break;
        case messagingChannelActions.unsubscribeArchiveStatus.match:
            managerInstance.unsubscribeArchiveStatus(action.payload);
            break;
        case messagingChannelActions.subscribeSessionStatus.match:
            managerInstance.subscribeSessionStatus(action.payload);
            break;
        case messagingChannelActions.unsubscribeSessionStatus.match:
            managerInstance.unsubscribeSessionStatus(action.payload);
            break;
        case messagingChannelActions.subscribeDownloadTrimStatus.match:
            managerInstance.subscribeDownloadTrimStatus(action.payload);
            break;
        case messagingChannelActions.unsubscribeDownloadTrimStatus.match:
            managerInstance.unsubscribeDownloadTrimStatus(action.payload);
            break;
        case messagingChannelActions.subscribeExportCSVStatus.match:
            managerInstance.subscribeExportCSVStatus(action.payload);
            break;
        case messagingChannelActions.unsubscribeExportCSVStatus.match:
            managerInstance.unsubscribeExportCSVStatus(action.payload);
            break;
        default:
            break;
    }
} 
